import { z } from "zod";
export var DmaPhase;
(function (DmaPhase) {
    DmaPhase["Aqueous"] = "Aqueous";
    DmaPhase["Solid"] = "Solid";
    DmaPhase["Gas"] = "Gas";
    DmaPhase["Organic"] = "Organic";
})(DmaPhase || (DmaPhase = {}));
export const dmaPhaseDtoSchema = z.nativeEnum(DmaPhase);
